export default "__VITE_ASSET__DRzWqz9___"